// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "82ca65873-dirty",
    "hash": "82ca65873",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "82ca65873-dirty",
    "semverString": null,
    "version": "--",
    "buildNumber": "2.11.1"
};
/* tslint:enable */
